import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import OrderTripService from "services/OrderTripService";

// DataPagingModel<TripGridDto>
export const searchTrip = createAsyncThunk(
  "orderTrip/searchTrip",
  async (data, { rejectWithValue }) => {
    try {
      const response = await OrderTripService.searchTrip(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// TripDetailDto
export const getTripDetail = createAsyncThunk(
  "orderTrip/getTripDetail",
  async (tripId, { rejectWithValue }) => {
    try {
      const response = await OrderTripService.getTripDetail(tripId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

// TripCountByStatusDto
export const getTripCountByStatus = createAsyncThunk(
  "orderTrip/getTripCountByStatus",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await OrderTripService.getTripCountByStatus(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  loadingCount: false,

  tripList: [],
  tripDetail: null,

  tripCountByStatus: {
    total: 0,
    unassigned: 0,
    assigned: 0,
    running: 0,
    completed: 0,
    cancelled: 0,
  },
};

export const orderTripSlice = createSlice({
  name: "orderTrip",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },

    clearTripDetail: (state) => {
      state.tripDetail = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // searchTrip
      .addCase(searchTrip.pending, (state) => {
        state.loading = true;
      })
      .addCase(searchTrip.fulfilled, (state, action) => {
        state.loading = false;
        state.tripList = action.payload;
      })
      .addCase(searchTrip.rejected, (state) => {
        state.loading = false;
      })

      // getTripDetail
      .addCase(getTripDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTripDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.tripDetail = action.payload;
      })
      .addCase(getTripDetail.rejected, (state) => {
        state.loading = false;
      })

      // getTripCountByStatus
      .addCase(getTripCountByStatus.pending, (state) => {
        state.loadingCount = true;
      })
      .addCase(getTripCountByStatus.fulfilled, (state, action) => {
        state.loadingCount = false;
        state.tripCountByStatus =
          action.payload ?? initialState.tripCountByStatus;
      })
      .addCase(getTripCountByStatus.rejected, (state) => {
        state.loadingCount = false;
      });
  },
});

export const {
  showLoading,
  clearTripDetail,
} = orderTripSlice.actions;

export default orderTripSlice.reducer;